/* eslint-disable jira/filename-case */
export const bannerHeight = 56;
export const BANNER_NAME = 'IP_BLOCK_LISTING_BANNER';
